import script from "./ThuChiDanhMucAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./ThuChiDanhMucAdmin.vue?vue&type=script&setup=true&lang=js"

import "./ThuChiDanhMucAdmin.vue?vue&type=style&index=0&id=43573ef8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43573ef8"]])

export default __exports__